<template>
  <div class="flex flex-col">
    <input
      ref="inputTag"
      v-bind="$attrs"
      :value="value"
      class="w-full px-4 py-3 bg-gray-400 outline-none"
      :class="inputClass"
      :type="type"
      v-if="type !== 'textarea'"
      :readonly="readonly"
      @input="$emit('input', $event.target.value)"
    />

    <textarea
      v-bind="$attrs"
      :value="value"
      class="block w-full h-full px-4 py-3 bg-gray-400 outline-none resize-none"
      :class="inputClass"
      v-if="type === 'textarea'"
      @input="$emit('input', $event.target.value)"
    />

    <label
      class="block mt-2 ml-4 text-left"
      :for="name"
      v-if="message"
      v-text="message"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },

  inheritAttrs: false,

  props: {
    name: String,
    value: String,
    message: String,
    type: String,
    location: Boolean,
    locationOptions: Object,
    inputClass: String,
    readonly: Boolean,
  },

  mounted() {
    if (this.location) {
      this.inputTag = new google.maps.places.Autocomplete(
        this.$refs.inputTag,
        this.locationOptions
      );

      this.inputTag.addListener("place_changed", () => {
        const place = this.inputTag.getPlace();

        this.$emit("input", place.name);
        this.$emit("locationChanged", place);
      });
    }
  },
};
</script>
